import React, { FC, ReactNode } from 'react';
import { useSpring, animated, config } from 'react-spring';
import styled from 'styled-components';
import { Input, IInputProps } from '@hox/ui/Input';
import { SmallText } from '@hox/ui/Typography';
import { TinyLoadingIndicator } from 'components/TinyLoadingIndicator';

interface IAuthInputProps extends IInputProps {
  errorText?: ReactNode;
  loading?: boolean;
}

const InputLoading = styled(TinyLoadingIndicator)``;

const AuthInputStyled = styled.div`
  position: relative;

  > ${InputLoading} {
    position: absolute;
    top: 50%;
    right: 1rem;

    /* minus half the height of TinyLoadingIndicator to center vertically */
    margin-top: -0.4rem;
  }

  > * {
    margin-bottom: 1rem;
    :last-child {
      margin-bottom: 0;
    }
  }
`;

const AuthInputError = styled(SmallText)`
  opacity: 1;
  font-weight: 600;
  color: ${({ theme }) => theme.palette.indicator.negative};
`;

export const AuthInput: FC<IAuthInputProps> = ({
  errored,
  errorText,
  loading,
  ...restProps
}) => {
  const errorSpring = useSpring({
    config: config.stiff,
    position: errored ? 'static' : 'absolute',
    opacity: errored ? 1 : 0,
    width: '100%',
  });

  return (
    <AuthInputStyled>
      {loading && <InputLoading />}
      <Input errored={errored} {...restProps} />
      <animated.div style={errorSpring}>
        <AuthInputError>{errorText}</AuthInputError>
      </animated.div>
    </AuthInputStyled>
  );
};
